import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Image,
  Text,
} from "@chakra-ui/react";
import React, { useState, useCallback, useMemo } from "react";
import logoMain from "../../assets/images/sider/logo-main.png";
import {
  enumMenu,
  EMPLOYEE_DEPARTMENT,
  MENU_DEPARTMENT_KEYWORDS,
} from "../../utils/contants";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";

// const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001/";

const toNoAccent = (text = "") =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase();

// Khối hỗ trợ KD nhưng phòng ban không có trong MENU_DEPARTMENT_KEYWORDS
// (hoặc chưa gắn phòng ban) => chỉ thấy nhóm menu không khai báo `departments`.
const NO_MENU_DEPARTMENT = "NONE";

// Phòng ban dùng để lọc menu. Chỉ lọc nhân viên khối hỗ trợ kinh doanh
// (kể cả có role ALL). Khối kinh doanh / khối giám đốc => trả null, menu chỉ
// lọc theo role như cũ.
const getMenuDepartment = (employee) => {
  if (employee?.department !== EMPLOYEE_DEPARTMENT.SUPPORT_BUSINESS) {
    return null;
  }
  const name = toNoAccent(employee?.supportDepartment?.name);
  if (!name) return NO_MENU_DEPARTMENT;
  const found = Object.entries(MENU_DEPARTMENT_KEYWORDS).find(([, keywords]) =>
    keywords.some((keyword) => name.includes(toNoAccent(keyword)))
  );
  return found ? found[0] : NO_MENU_DEPARTMENT;
};

const Sider = () => {
  const [activeItems, setActiveItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.login?.currentUser);
  const roles = user?.roles || [];
  const menuDepartment = useMemo(
    () => getMenuDepartment(user?.user),
    [user]
  );

  const hasPermission = useCallback(
    (itemRoles) =>
      itemRoles?.some((role) => roles.includes(role)) || roles.includes("ALL"),
    [roles]
  );

  const isVisibleForDepartment = useCallback(
    (item) =>
      (!item.employeeDepartments ||
        item.employeeDepartments.includes(user?.user?.department)) &&
      (menuDepartment === null ||
        !item.departments ||
        item.departments.includes(menuDepartment)),
    [menuDepartment, user]
  );

  const handleToggle = useCallback(
    (item) => {
      setActiveItems((prev) => (prev === item.name ? null : item.name));
      navigate(item.path);
    },
    [navigate]
  );

  const handleNavigate = useCallback(
    (path) => {
      navigate(path);
    },
    [navigate]
  );

  return (
    <Flex flexDirection="column" w="250px" h="100vh">
      {/* Logo */}
      <Box h="80px" p="10px 78px">
        <Image src={logoMain} alt="Logo" />
      </Box>

      {/* Menu Accordion */}
      <Accordion allowToggle w="250px" bg="var(--color-sidermain)">
        {enumMenu
          .filter(
            (item) => hasPermission(item.role) && isVisibleForDepartment(item)
          )
          .map((item) => (
            <AccordionItem
              border="none"
              key={item.name}
              bg={
                activeItems === item.name
                  ? "var(--color-sidersecondary)"
                  : "var(--color-sidermain)"
              }
              _hover={{ bg: "var(--color-hover)" }}
              transition="background-color 0.3s ease"
            >
              <h2>
                <AccordionButton
                  display="flex"
                  alignItems="center"
                  gap="15px"
                  p="12px 20px"
                  onClick={() => handleToggle(item)}
                >
                  <Flex
                    as="span"
                    flex="1"
                    textAlign="left"
                    alignItems="center"
                    gap="12px"
                  >
                    <Image src={item.icon} alt={item.name} />
                    <Text
                      fontSize="15px"
                      fontWeight="600"
                      color={
                        location.pathname === item.path
                          ? "var(--color-option-employee-hover)"
                          : "var(--color-main)"
                      }
                    >
                      {item.name}
                    </Text>
                  </Flex>
                  {item.children && (
                    <AccordionIcon
                      color="var(--color-main)"
                      transform={
                        activeItems === item.name
                          ? "rotate(0deg)"
                          : "rotate(-90deg)"
                      }
                      transition="transform 0.3s ease"
                    />
                  )}
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                {item.children && (
                  <Box>
                    {item.children
                      .filter((subItem) => hasPermission(subItem.role))
                      .map((subItem) => (
                        // <Box
                        //   key={subItem.name}
                        //   p="12px 0px 12px 44px"
                        //   cursor="pointer"
                        //   onClick={() => handleNavigate(subItem.path)}
                        //   _hover={{ color: "var(--color-hover)" }}
                        // >
                        //   <Text
                        //     fontSize="14px"
                        //     fontWeight="500"
                        //     className={location.pathname === subItem.path ? "text-liner" : "text-unclick"}
                        //   >
                        //     {subItem.name}
                        //   </Text>
                        // </Box>
                        <Link
                          to={subItem.path}
                          key={subItem.name}
                          style={{ textDecoration: "none" }}
                        >
                          <Box
                            p="12px 0px 12px 44px"
                            cursor="pointer"
                            _hover={{ color: "var(--color-hover)" }}
                          >
                            <Text
                              fontSize="14px"
                              fontWeight="500"
                              className={
                                location.pathname === subItem.path
                                  ? "text-liner"
                                  : "text-unclick"
                              }
                            >
                              {subItem.name}
                            </Text>
                          </Box>
                        </Link>
                      ))}
                  </Box>
                )}
              </AccordionPanel>
            </AccordionItem>
          ))}
      </Accordion>
    </Flex>
  );
};

export default React.memo(Sider);
